
document.addEventListener('DOMContentLoaded', (event) => {
  var fabricFilters = document.querySelectorAll('.nugget-fabric-button');

  // get the current URL
  var currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.has('filter')) {
    
    if (currentUrl.searchParams.get('filter').trim().length <= 0) {
      return;
    }

    if (currentActiveFilterClass != null) {
      currentActiveFilterClass.classList.remove('active');
    } else {
      fabricFilters.forEach(activeFilter => {
        activeFilter.classList.remove('active');
      });
    }
    
    fabricFilters.forEach(fabricFilter => {
      if (! fabricFilter.dataset.nuggetFilter || fabricFilter.dataset.nuggetFilter == '') {
        return;
      }
      if (fabricFilter.dataset.nuggetFilter.toLowerCase() == currentUrl.searchParams.get('filter').toLowerCase()) {
        filterNuggetProducts(fabricFilter);
        fabricFilter.classList.add('active');
      }
    });
  }

  var currentActiveFilterClass = null;
  fabricFilters.forEach(fabricFilter => {
    fabricFilter.addEventListener('click', () => {
      if (! fabricFilter.dataset.nuggetFilter || fabricFilter.dataset.nuggetFilter == '') {
        return;
      }
      if (currentActiveFilterClass != null) {
        currentActiveFilterClass.classList.remove('active');
      } else {
        fabricFilters.forEach(activeFilter => {
          activeFilter.classList.remove('active');
        });
      }
      filterNuggetProducts(fabricFilter);
    })
  })

  function filterNuggetProducts(fabricFilter) {
    // iterate through the available options and select the first match
    if (document.querySelector('collection-pdp-loader')) {
      var productCollection = document.querySelector('collection-pdp-loader');
      var products = productCollection.querySelectorAll('.gg-btn');
      var selectedProductActive = false;
      var firstProductInSelectionList = null;
      products.forEach(product => {
        if (product.dataset.productFabricType == '') {
          return;
        } 
        try {
          var mapOptions = JSON.parse(product.dataset.productFabricType);
          if (fabricFilter.dataset.nuggetFilter.toLowerCase() == 'all') {
            product.classList.remove('hidden');
            selectedProductActive = true;
            firstProductInSelectionList = null;
          } else if (typeof mapOptions == 'object') {

            var mappedComponentFound = false;
            mapOptions.findIndex(element => {
              if (element.toLowerCase() == fabricFilter.dataset.nuggetFilter.toLowerCase()) {
                product.classList.remove('hidden');
                mappedComponentFound  = true;
                // selects the first active product in the selection criteria
                if (firstProductInSelectionList == null) {
                  firstProductInSelectionList = product;
                }
                if (product.classList.contains('active')) {
                  selectedProductActive = true;
                  return -1;
                }
              } 
              // component does not exist in the mapped list
              if (mappedComponentFound == false) {
                product.classList.add('hidden');
              }
              
            });

          } else {
            product.classList.add('hidden');
          }
        } catch (e) {
          console.log('Skipping (' + product.dataset.productId + ') due to: ' + e);
        }
      });


      if (selectedProductActive == false && firstProductInSelectionList != null && typeof firstProductInSelectionList == 'object') {
        firstProductInSelectionList.click();
      }
      if (typeof fabricFilter == 'object') {
        fabricFilter.classList.add('active');
        currentActiveFilterClass = fabricFilter;
        // change the URL fragment to include this filter
        if (fabricFilter.dataset.nuggetFilter.toLowerCase() != 'all') {
          var currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('filter', fabricFilter.dataset.nuggetFilter);
          window.history.replaceState({}, '', currentUrl.toString());
        } else {
          var currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('filter');
          window.history.replaceState({}, '', currentUrl.toString());      
        }
      }
    }    
  }
});

